import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import cl from '../BaseSimplePage/BaseSimpleItemEditor.module.css'
import {Alert, LinearProgress} from "@mui/material";
import WeightCoefficientsForm from "./WeightCoefficientsForm";
import WeightCoefficientsEditorFooter from "./WeightCoefficientsEditorFooter";
import WeightCoefficientsEditorHeader from "./WeightCoefficientsEditorHeader";
import ServerManager from "../../API/ServerManager";

const WeightCoefficientsEditor = forwardRef(({
                                    onSave,
                                    setSnackbarData,
                                }, ref) => {

    useImperativeHandle(ref, () => ({
        tryValidateAndGetFormData: tryValidateAndGetFormData,
    }));

    const [isLoading, setIsLoading] = React.useState(true);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [formData, setFormData] = useState(null);
    const formControlRef = useRef(null);

    useEffect(() => {
        async function fetch() {
            setIsLoading(true);
            setFormData(null);
            try {
                const response = await ServerManager.getWeightCoefficients();
                const newFormData = response.coefficients;
                if (!ignore) {
                    setFormData(newFormData);
                }
            } catch (error) {
                if (!ignore) {
                    setErrorMessage(`Ошибка при загрузке данных: ${error}`);
                }
            } finally {
                if (!ignore) setIsLoading(false);
            }
        }

        let ignore = false;
        fetch();
        return () => {
            ignore = true;
        }
    }, []);

    function handleSaveBtnClick() {
        const data = tryValidateAndGetFormData();
        if (data)
            onSave(data);
    }

    function tryValidateAndGetFormData() {
        if (!formControlRef.current.validate()) {
            setSnackbarData({
                severity: "error",
                title: "Ошибка в заполнении!",
                message: "Необходимо исправить отмеченные поля"
            });
            return false;
        }

        return formControlRef.current.getData();
    }

    function renderFooter(props) {
        return <WeightCoefficientsEditorFooter {...props}/>
    }

    return (
        <div className={cl.main}>
            <WeightCoefficientsEditorHeader/>
            <div className={cl.scrollContent}>
                {isLoading && <LinearProgress/>}
                {!isLoading && errorMessage && <Alert variant="outlined" severity="error">{errorMessage}</Alert>}
                {!isLoading && !errorMessage && <WeightCoefficientsForm
                    initData={formData}
                    controlRef={formControlRef}
                />}
            </div>
            {!isLoading && !errorMessage && renderFooter({
                onSaveBtnClick: handleSaveBtnClick,
            })}
        </div>
    );
});

export default WeightCoefficientsEditor;